import { ServiceOrderIdsQueryBody, ServiceOrdersQueryBody } from '../../types/serviceOrder/queryBody.types';
import { mapServiceOrderStatusesToApiStatuses, mapToServiceOrderApiSort } from './serviceOrderQueryParamsMapper';
import { GetServiceOrdersFilterQueryParams, GetServiceOrdersQueryParams } from '../../serviceOrdersApi';
import { mapServiceTypesToApiServiceTypes } from './serviceTypeMapper';

export const mapToServiceOrderQueryBody = (queryParameters: GetServiceOrdersQueryParams): ServiceOrdersQueryBody => {
    const filter = mapToServiceOrderFilterQueryParameters(queryParameters);
    const hasSomeFilter = Object.values(filter).some((value) => value !== undefined);

    return {
        filter: hasSomeFilter ? filter : undefined,
        sort: queryParameters.sortBy && mapToServiceOrderApiSort(queryParameters.sortBy),
        limit: queryParameters.limit,
    };
};

export const mapToServiceOrderFilterQueryParameters = (
    queryParameters: GetServiceOrdersFilterQueryParams,
): ServiceOrderIdsQueryBody => ({
    statuses: queryParameters.statuses && mapServiceOrderStatusesToApiStatuses(queryParameters.statuses),
    service_types: queryParameters.serviceTypes && mapServiceTypesToApiServiceTypes(queryParameters.serviceTypes),
    order_issued_at: mapOrderIssuedAtIntervalFilter(
        queryParameters.orderIssuedAtAfter,
        queryParameters.orderIssuedAtBefore,
    ),
    service_location: queryParameters.location,
    vin_search: queryParameters.vins,
    external_order_id: queryParameters.externalOrderId,
    external_option_id: queryParameters.externalOptionId,
    archived: queryParameters.archived,
});

const mapOrderIssuedAtIntervalFilter = (from: Date | undefined, to: Date | undefined) => {
    if (from === undefined && to === undefined) {
        return undefined;
    }

    return {
        start_at: from?.toISOString(),
        end_at: to?.toISOString(),
    };
};
